export const state = (state) => {
  return state;
};
